import {DEFAULT_PATH} from './APIPath'

export class MyEventSource extends EventSource{

    constructor(url: string) {
        super(DEFAULT_PATH + url);
    }
}